import React from 'react';
import SafeCallComponent from "../../../lab-orders/LabOrderItem/children/SafeCallComponent";

const LabOrderItemKeyValueDetails = (props) => {
    const {customer_contact_phone, customer_address, biker_details,actual_price,order_type} = props;


    return (
        <div className="pharmacy-order-key-value-details">
            <div className="key-value-details-holder">
                {actual_price !== '0' && actual_price !== 0 && (
                    <div className="key-value-item">
                        <div className="key">مبلغ سفارش:</div>
                        <div className="value">{actual_price} تومان</div>
                    </div>
                )}
                <div className="key-value-item">
                    <div className="key">شماره تماس کاربر :</div>
                    <div className="value">{customer_contact_phone}</div>
                </div>
                {
                    order_type === 'drug' ?
                        null :
                        <div className="key-value-item">
                            <div className="key">آدرس کاربر :</div>
                            <div className="value">{customer_address}</div>
                        </div>
                }

                {
                    biker_details !== null ?
                        <div className="key-value-item">
                            <div className="key">نام پیک :</div>
                            <div className="value">{biker_details.name}</div>
                        </div>
                        : null
                }
                {
                    biker_details !== null ?
                        <div className="key-value-item">
                            <div className="key">شماره تماس پیک :</div>
                            <div className="value">{biker_details.phone}</div>
                        </div>
                        : null
                }
                <SafeCallComponent order={props} />
            </div>

        </div>
    )
};

export default LabOrderItemKeyValueDetails;